var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgreement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-50.41 29.865",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 505.073 573.577)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-37.143 22.005",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 463.249 603.755)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-14.555 8.622",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 412.561 628.682)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h245.224",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 119.658 193.763)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h122.612",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 119.658 124.092)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h245.224",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 119.658 255.495)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-52.567C0-69.63 13.832-83.461 30.894-83.461h52.567",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(302.907 502.392)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v128.279c0 6.207-2.466 12.16-6.854 16.549l-71.86 71.86a23.408 23.408 0 0 1-16.55 6.855H-321.35c-17.061 0-30.893-13.831-30.893-30.894v-397.944c0-17.062 13.832-30.893 30.893-30.893h78.478",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(388.477 280.957)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-15.524 9.197a8.989 8.989 0 0 1-12.315-3.151l-63.827-107.737a8.989 8.989 0 0 1 3.152-12.315l15.525-9.197c10.413-6.169 23.855-2.729 30.025 7.684L7.685-30.025C13.854-19.611 10.414-6.169 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(187.733 241.106)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 23.738-40.07c6.17-10.413 19.613-13.854 30.026-7.685l15.525 9.197a8.988 8.988 0 0 1 3.151 12.315L8.613 81.494a8.988 8.988 0 0 1-12.314 3.152l-15.525-9.198c-10.413-6.169-13.854-19.611-7.684-30.025l8.954-15.114",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(402.07 165.657)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.561 1.516C-17.287 9.967-24.174 11.529-37.46 6.394L-51.94.795a30.83 30.83 0 0 0-26.828 2.231l-8.954 5.28",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(284.51 205.568)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 15.005-8.856",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(141.314 121.194)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24.023-14.232c8.425-4.992 19.301-2.207 24.292 6.217 4.992 8.425 2.207 19.301-6.217 24.292l19.94-11.813c8.426-4.991 19.302-2.208 24.293 6.217 4.991 8.424 2.207 19.3-6.218 24.292l13.294-7.876c8.425-4.991 19.301-2.207 24.292 6.217 4.991 8.425 2.207 19.301-6.218 24.292l16.27-9.638c8.424-4.99 19.299-2.207 24.289 6.217 4.991 8.424 2.208 19.298-6.216 24.29",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(267.323 24.21)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.088-1.214a30.827 30.827 0 0 0-26.828-2.231l-16.33 6.416a26.242 26.242 0 0 1-16.035 1.014l-25.021-6.332c-11.647-2.947-19.806-13.428-19.806-25.443v-33.399c0-4.723 3.827-8.564 8.549-8.567 14.241-.009 25.788 11.532 25.788 25.771v1.414l107.097-63.421a30.856 30.856 0 0 0 6.761 5.423l15.174 8.865",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(375.912 209.809)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.709-7.952-16.784-9.771-24.736-4.062-7.952 5.709-9.771 16.785-4.062 24.737l10.04 13.985c5.71 7.952 16.784 9.772 24.737 4.062 7.953-5.709 9.771-16.784 4.062-24.736",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(173.277 75.576)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-21.122-29.42c-5.709-7.953-16.784-9.771-24.736-4.062-7.953 5.709-9.771 16.784-4.062 24.736l21.121 29.421c5.71 7.952 16.784 9.77 24.737 4.061C3.891 19.027 5.709 7.953 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(223.197 84.322)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.709 7.953 16.783 9.771 24.735 4.062 7.953-5.708 9.772-16.784 4.063-24.736L7.676-50.095c-5.709-7.952-16.783-9.77-24.737-4.061-7.952 5.709-9.77 16.783-4.061 24.736",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(223.197 84.322)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.709 7.952 16.784 9.771 24.736 4.062v0c7.952-5.709 9.772-16.784 4.062-24.736l-7.024-9.784C16.065-38.41 4.991-40.229-2.962-34.52c-7.952 5.709-9.77 16.785-4.061 24.737",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(242.61 50.575)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/agreement.4405ce7b455165d0b3d1ec94cc9ed9e1.svg";
export { ForwardRef as ReactComponent };